import { Link } from "react-router-dom";
import useTranslate from "../../hooks/useTranslate";

// Settings sidebar — Lawyers V2 follow-up A4 (FOLLOWUP-PACK-BRIEF, C23).
// Geometry per artboards 1i/1j: 216px white rail, right border #E6EAF2,
// "Settings" eyebrow, 8/12 row padding, active row #EBF3FF/#1567D2.
//
// SCOPE (Marin's decision): the rail renders ONLY entries with a REAL route
// behind them. The artboards' "Account" / "Agency profile" / "Billing" rows
// have NO pages and NO routes anywhere (FUNCTION-TODO row 7) and are
// deliberately NOT rendered — building those pages is explicitly out of
// scope. Entries here map 1:1 to existing routes in src/routes/index.js:
//   /settings/lawyer-profile  → pages/settings/LawyerProfileSettings.js
//   /settings/notifications   → pages/settings/NotificationSettings.js
//   /settings/security        → pages/settings/SecuritySettings.js
// Desktop-only chrome (1i/1j have no mobile boards; below md the settings
// page keeps its existing 1-col stack).
const ENTRIES = [
  {
    key: "lawyer-profile",
    label: "Lawyer profile",
    to: "/settings/lawyer-profile",
  },
  { key: "notifications", label: "Notifications", to: "/settings/notifications" },
  { key: "security", label: "Security", to: "/settings/security" },
];

const SettingsSidebar = ({ active }) => {
  const { t } = useTranslate();
  return (
    <nav
      aria-label={t("Settings")}
      className="hidden md:flex w-[216px] flex-none flex-col gap-[2px] bg-white border-r border-[#E6EAF2] px-3 py-[22px]"
    >
      <div className="text-[11px] font-bold text-[#98A2B3] tracking-[0.6px] uppercase px-3 mb-[10px]">
        {t("Settings")}
      </div>
      {ENTRIES.map((entry) =>
        entry.key === active ? (
          <span
            key={entry.key}
            aria-current="page"
            className="px-3 py-2 text-[13px] font-semibold text-[#1567D2] bg-[#EBF3FF] rounded-[8px]"
          >
            {t(entry.label)}
          </span>
        ) : (
          <Link
            key={entry.key}
            to={entry.to}
            className="px-3 py-2 text-[13px] font-medium text-[#475467] rounded-[8px] hover:bg-[#F5F7FB] hover:text-[#101828] transition-colors"
          >
            {t(entry.label)}
          </Link>
        )
      )}
    </nav>
  );
};

export default SettingsSidebar;
